import React, { useState, useEffect } from 'react';
import './kanban.css';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Chip, Divider, IconButton, FormControlLabel, Checkbox, Tooltip, LinearProgress, CircularProgress } from '@mui/material';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTaskContext } from '../../shared/context/taskContext';
import moment from 'moment';
import { useUtiles } from '../../shared/context/utilesContext';
import { styled } from '@mui/material/styles';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import { useNavigate } from 'react-router';
import { useOt } from '../../shared/context/otContext';
import CommentToMoveOt from '../task/components/DetailOt/CommentToMoveOt';
import { useAuth } from '../../shared/context/authContext';
import ManageTaskScheduledComponent from '../task/components/scheduled/ManageTaskScheduledComponent';
import { useScheduled } from '../../shared/context/scheduledContext';


const Kanban = ({ tasks = {}, loadingTasks = false }) => {
    const [draggedTask, setDraggedTask] = useState(null);
    const [dragOverColumn, setDragOverColumn] = useState(null);
    const theme = useTheme();
    const { priorityOptions, getFirstNameAndLastName, sumaTimeDurationTask, convertHoursToDaysAndHours, openSilderWith, setAlertSnackbar } = useUtiles();
    const { selectedTaskPending, handleSelectTaskPending, setOtWithTaskPending, deleteTask, loadingDeleteTask, isUpdateTask, setIsUpdateTask, setTask, setSubtaskList } = useTaskContext();
    const { setOtSelectToMove } = useOt()


    const { setTaskScheduled, setSubtaskScheduledList, resetSubtaskScheduled, resetTaskScheduled } = useScheduled();


    //obtener el rol del usuario
    const { authUser } = useAuth();
    const role = authUser ? authUser.role : null;


    const navigate = useNavigate();

    useEffect(() => {
        // console.log('Tasks recibidas:', tasks)
    }, [tasks])

    const columns = {
        pending: {
            title: 'Tareas Pendientes',
            items: tasks.pending || [],
            status: 'pending'
        },
        in_process: {
            title: 'OTs en Proceso',
            items: tasks.in_process || [],
            status: 'in_process'
        },
        review: {
            title: 'OTs en Revisión',
            items: tasks.review || [],
            status: 'review'
        },
        completed: {
            title: 'OTs Finalizadas',
            items: tasks.completed || [],
            status: 'completed'
        }
    };

    useEffect(() => {
        // console.log('Columnas procesadas:', columns)
    }, [columns])

    const columnNames = {
        pending: 'Tareas Pendientes',
        in_process: 'OTs en Proceso',
        review: 'OTs en Revisión',
        completed: 'OTs Finalizadas'
    };

    const handleDragStart = (e, task) => {
        console.log('Iniciando drag con tarea:', task);
        const taskWithStatus = {
            ...task,
            status: task.status || 'pending'
        };
        setDraggedTask(taskWithStatus);

        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e, columnId) => {
        e.preventDefault();
        setDragOverColumn(columnId);
    };

    const handleDragLeave = () => {
        setDragOverColumn(null);
    };

    const handleUpdateTask = (task) => {
        console.log('task', task)

        if (task.is_scheduled) {
           
            setTaskScheduled({
                ...task,
                typeTask: task.type_task,
                required_ssoma_document: task.required_ssoma_document ? 'SI' : 'NO',
            })
        const scheduledSubtasks = task.subtasks || [];
        setSubtaskScheduledList(scheduledSubtasks.map(subtask => ({
                ...subtask,
                options: subtask.values
            })))
            openSilderWith(<ManageTaskScheduledComponent readOnly={true} />, 500, 'Regresar a proceso')
            return;
        }
        setIsUpdateTask(true)
        setTask({
            ...task,
            asset: task.assets?.[0],
            typeTask: task.type_task,
            required_ssoma: task.required_ssoma_document
        })
        const taskSubtasks = task.subtasks || [];
        setSubtaskList(taskSubtasks.map(subtask => ({
            ...subtask,
            options: subtask.values
        })))
        navigate('/task/wo/create')
    }

    const handleDrop = (e, targetStatus) => {
        e.preventDefault();
        setDragOverColumn(null);

        if (draggedTask) {
            const sourceColumn = draggedTask.status;
            const columnOrigin = columnNames[sourceColumn] || sourceColumn;
            const columnDestination = columnNames[targetStatus] || targetStatus;

            // Si el origen y destino son iguales, no hacemos nada
            if (sourceColumn === targetStatus) {
                return;
            }

            // Verificamos si es una tarea pendiente o una OT
            const isPendingTask = sourceColumn === 'pending' && !draggedTask.ot_number;

            //Para pasar de pending a in_process
            if (isPendingTask && targetStatus === 'in_process') {
                setOtWithTaskPending(prev => ({ ...prev, task_list: [...prev.task_list, draggedTask] }))
                navigate('/task/wo/create-ot')
            }

            //Para pasar de in_process a review
            if (sourceColumn === 'in_process' && targetStatus === 'review') {
                setOtSelectToMove({ ...draggedTask, hash_code: draggedTask.ot_hash_code, calculate_completed: draggedTask.ot_calculate_completed })
                openSilderWith(<CommentToMoveOt toStatus='review' />, 500, 'Enviar a revisión')
            }

            //Para pasar de review a completed
            if (sourceColumn === 'review' && targetStatus === 'completed') {
                //si el rol del usuario tiene can_finish_ot = true, se puede finalizar la OT
                if (!role.can_finish_ot) {
                    setAlertSnackbar({
                        open: true,
                        message: 'No tienes permisos para finalizar esta OT',
                        severity: 'error'
                    })
                    return;
                }

                setOtSelectToMove({ ...draggedTask, hash_code: draggedTask.ot_hash_code, calculate_completed: draggedTask.calculate_completed })
                openSilderWith(<CommentToMoveOt toStatus='completed' />, 500, 'Finalizar OT')

            }

            //Regresar de review a in_process
            if (sourceColumn === 'review' && targetStatus === 'in_process') {
                if (!role.can_return_ot_pending) {
                    setAlertSnackbar({
                        open: true,
                        message: 'No tienes permisos para regresar esta OT a proceso',
                        severity: 'error'
                    })
                    return;
                }
                setOtSelectToMove({ ...draggedTask, hash_code: draggedTask.ot_hash_code, calculate_completed: draggedTask.calculate_completed })
                openSilderWith(<CommentToMoveOt toStatus='in_process' />, 500, 'Regresar a proceso')
            }


        }
        setDraggedTask(null);
    };

    // Tooltip personalizado para fondo
    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            boxShadow: theme.shadows[2],
            fontSize: 13,
        },
    }));

    const cardTask = (task, isDragging) => {
        return (
            <Box
                onClick={() => handleUpdateTask(task)}
                key={task.id}
                className={`task-card${isDragging ? ' dragging' : ''}`}
                sx={{
                    py: 1,
                    px: 2,
                    borderRadius: 2,
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
                    mb: 2,
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': {
                        boxShadow: theme.shadows[4]
                    },

                    cursor: 'pointer',

                    opacity: isDragging || selectedTaskPending.includes(task) ? 0.5 : 1
                }}
                draggable
                onDragStart={(e) => handleDragStart(e, task)}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: '25px'
                                    }
                                }}
                                checked={selectedTaskPending.includes(task)}
                                onChange={(e) => handleSelectTaskPending(task)}
                            />
                        }
                    />

                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                            Activo: {task.assets?.[0]?.name || 'Sin activo'}
                        </Typography>
                        <Typography variant="subtitle2" sx={{ fontSize: '14px' }}>Tarea: {task.description}</Typography>
                    </Box>

                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                        {task.priority && priorityOptions.find(option => option.value === task.priority) && (
                            <Tooltip title={task.priority}>
                                <Box>
                                    {priorityOptions.find(option => option.value === task.priority).icon}
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                </Box>


                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Chip
                        size='small'
                        sx={{ borderRadius: '5px' }}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <TimerOutlinedIcon sx={{ fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ ml: 1, fontWeight: 'bold', fontSize: '12px' }}>{convertHoursToDaysAndHours(task.time_duration)}</Typography>
                            </Box>
                        }
                    />
                    <Chip
                        size='small'
                        sx={{ borderRadius: '5px' }}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CalendarMonthOutlinedIcon sx={{ fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ ml: 1, fontWeight: 'bold', fontSize: '12px' }}>{moment(task.datetime_start_estimated).format('DD/MM/YYYY')}</Typography>
                            </Box>
                        }
                    />
                </Box>
                <Divider sx={{ mt: 2 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>

                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        backgroundColor: task.is_scheduled ? '#4CAF50' : '#FF9800', 
                        px: 0.6, 
                        py: 0.5, 
                        borderRadius: '4px',
                        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <CalendarMonthOutlinedIcon sx={{ fontSize: '16px', color: '#fff' }} />
                        <Typography variant="subtitle2" sx={{ ml: 1, fontWeight: 'bold', fontSize: '11px', color: '#fff' }}>
                            {task.is_scheduled ? 'PROGRAMADA' : 'NO PROGRAMADA'}
                        </Typography>
                    </Box>



                    {task.is_scheduled ? null : <IconButton onClick={(e) => { e.stopPropagation(); deleteTask(task.id) }} disabled={loadingDeleteTask}>
                        {loadingDeleteTask ? <CircularProgress size={20} /> : <DeleteOutlineOutlinedIcon sx={{ fontSize: '25px' }} />}
                    </IconButton>}
                </Box>
            </Box>
        )
    }

    const cardOt = (ot, isDragging, status) => {
        const hasMultipleTasks = ot.tasks && ot.tasks.length > 1;
        const allAssets = ot.tasks ? ot.tasks.flatMap(task => task.assets || []) : [];
        const uniqueAssets = Array.from(new Set(allAssets.map(asset => asset.name)))
            .map(name => allAssets.find(asset => asset.name === name));
        // Agrupar tareas por prioridad y guardar descripciones
        const priorityMap = ot.tasks ? ot.tasks.reduce((acc, task) => {
            if (task.priority) {
                if (!acc[task.priority]) acc[task.priority] = { count: 0, descriptions: [] };
                acc[task.priority].count += 1;
                acc[task.priority].descriptions.push(task.description);
            }
            return acc;
        }, {}) : {};
        return (
            <Box
                onClick={() => navigate(`/task/wo/detail-ot/${ot.ot_hash_code}`)}
                key={ot.hash_code + ot.ot_number}
                className={`task-card${isDragging ? ' dragging' : ''}`}
                sx={{
                    opacity: ot.status === 'cancel' ? 0.5 : 1,
                    py: 1,
                    px: 2,
                    borderRadius: 2,
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
                    mb: 2,
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': {
                        boxShadow: theme.shadows[4]
                    },
                    '&:before': {
                        background: status === 'in_process' ? theme.palette.primary.main : status === 'review' ? theme.palette.warning.main : status === 'completed' ? theme.palette.success.main : theme.palette.text.secondary
                    },
                    cursor: 'pointer',

                    borderBottom: '1px solid',
                    borderBottomWidth: '3px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: status === 'in_process' ? theme.palette.primary.main : status === 'review' ? theme.palette.warning.main : status === 'completed' ? theme.palette.success.main : theme.palette.text.secondary
                }}
                draggable
                onDragStart={(e) => handleDragStart(e, ot)}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '16px', color: theme.palette.text.secondary }}>{ot.ot_number}</Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'normal', fontSize: '11px', color: theme.palette.text.secondary }}>Creado por: {getFirstNameAndLastName(ot.created_by)}</Typography>
                </Box>

                {hasMultipleTasks ? (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        {/* Activos */}
                        <CustomTooltip
                            title={
                                <Box>
                                    {uniqueAssets.map((asset, idx) => (
                                        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}>
                                            <WidgetsRoundedIcon />
                                            <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: 'bold' }}>{asset.name}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            }
                            arrow
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 60 }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Activos</Typography>
                                <Chip
                                    size="small"
                                    icon={<Checkbox checked={true} sx={{ p: 0, pointerEvents: 'none' }} />}
                                    label={uniqueAssets.length}
                                    sx={{ m: 0, borderRadius: 1, fontWeight: 'bold' }}
                                />
                            </Box>
                        </CustomTooltip>
                        {/* Tareas */}
                        <CustomTooltip
                            title={
                                <Box>
                                    {Object.entries(priorityMap).map(([priority, data]) => {
                                        const option = priorityOptions.find(option => option.value === priority);
                                        return (
                                            <Box key={priority} sx={{ mb: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2 }}>
                                                    {option && <Box sx={{ mr: 0.5, display: 'flex', alignItems: 'center' }}>{option.icon}</Box>}
                                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Prioridad {priority}: {data.count}</Typography>
                                                </Box>
                                                <Box sx={{ pl: 3 }}>
                                                    {data.descriptions.map((desc, idx) => (
                                                        <Typography key={idx} variant="body2" sx={{ fontSize: '14px', fontWeight: 'bold', color: theme.palette.text.secondary }}>
                                                            • {desc}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            }
                            arrow
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 60 }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Tareas:</Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    {Object.entries(priorityMap).map(([priority, data]) => {
                                        const option = priorityOptions.find(option => option.value === priority);
                                        return option ? (
                                            <Chip
                                                key={priority}
                                                size="small"
                                                icon={option.icon}
                                                label={data.count}
                                                sx={{ borderRadius: 1, fontWeight: 'bold', mr: 0.5 }}
                                            />
                                        ) : null;
                                    })}
                                </Box>
                            </Box>
                        </CustomTooltip>
                    </Box>
                ) : (
                    // Solo una tarea: mostrar activo y tarea
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Activo: {ot.tasks?.[0]?.assets?.[0]?.name || 'Sin activo'}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ fontSize: '14px' }}>
                                Tarea: {ot.tasks?.[0]?.description || 'Sin tarea'}
                            </Typography>
                        </Box>
                        {
                            ot.tasks?.[0]?.priority && priorityOptions.find(option => option.value === ot.tasks?.[0]?.priority) && (
                                <Box>
                                    {priorityOptions.find(option => option.value === ot.tasks?.[0]?.priority).icon}
                                </Box>
                            )
                        }
                    </Box>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Chip
                        size='small'
                        sx={{ borderRadius: '5px' }}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <TimerOutlinedIcon sx={{ fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ ml: 1, fontWeight: 'bold', fontSize: '12px' }}>{convertHoursToDaysAndHours(sumaTimeDurationTask(ot.tasks))}</Typography>
                            </Box>
                        }
                    />
                    <Chip
                        size='small'
                        sx={{ borderRadius: '5px' }}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CalendarMonthOutlinedIcon sx={{ fontSize: '18px' }} />
                                <Typography variant="subtitle2" sx={{ ml: 1, fontWeight: 'bold', fontSize: '12px' }}>{moment(ot.ot_datetime_start_estimated).format('DD/MM/YYYY')}</Typography>
                            </Box>
                        }
                    />
                </Box>

                <Box sx={{ mt: 1, mb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ flexGrow: 1, mr: 1 }}>
                            <LinearProgress
                                variant="determinate"
                                value={ot.ot_calculate_completed || 0}
                                sx={{
                                    height: "5px",
                                    borderRadius: "2px",
                                    bgcolor: theme.palette.grey[200],
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: status === 'in_process' ? theme.palette.primary.main :
                                            status === 'review' ? theme.palette.warning.main :
                                                status === 'completed' ? theme.palette.success.main :
                                                    theme.palette.text.secondary
                                    }
                                }}
                            />
                        </Box>
                        <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '12px' }}>
                            {`${Math.round(ot.ot_calculate_completed || 0)}%`}
                        </Typography>
                    </Box>
                </Box>







                {/* Assigned User Information */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: theme.palette.text.secondary }}>Asignado a:</Typography>
                            {ot.assigned_to ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {ot.assigned_to.avatar ? (
                                        <Box
                                            component="img"
                                            src={ot.assigned_to.avatar}
                                            alt={ot.assigned_to.full_name}
                                            sx={{
                                                width: 24,
                                                height: 24,
                                                borderRadius: '50%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                width: 24,
                                                height: 24,
                                                borderRadius: '50%',
                                                bgcolor: theme.palette.primary.main,
                                                color: 'white',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '12px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {ot.assigned_to.full_name.charAt(0).toUpperCase()}
                                        </Box>
                                    )}
                                    <Typography variant="body2" sx={{ fontSize: '11px !important', fontWeight: 'bold' }}>{getFirstNameAndLastName(ot.assigned_to.full_name).toUpperCase()}</Typography>
                                </Box>
                            ) : (
                                <Typography variant="body2" color="text.secondary">Sin asignar</Typography>
                            )}
                        </Box>
                    </Box>
                    {/* AGREGAR CHIP DE STATUS CANCELADO */}
                    {ot.status === 'cancel' && (
                        <Chip
                            size='small'
                            sx={{ borderRadius: '5px', backgroundColor: "#000", color: 'white', fontWeight: 'bold' }}
                            label={<Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '12px', color: 'white !important' }}>Cancelado</Typography>}
                        />
                    )}
                </Box>
            </Box>
        );
    };



    return (
        <Box className="kanban-container" sx={{ p: { xs: 1, md: 2 }, gap: { xs: 1, md: 1 } }}>
            {Object.entries(columns).map(([columnId, column]) => {
                return (
                    <div
                        key={columnId}
                        className={`kanban-column${dragOverColumn === columnId ? ' drag-over' : ''}`}
                        onDragOver={(e) => handleDragOver(e, columnId)}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) => handleDrop(e, columnId)}
                        style={{ backgroundColor: theme.palette.background.paper2 }}
                    >
                        <h2 className="column-title" style={{ color: theme.palette.text.primary }}>
                            {column.title} ({column.items.length})
                        </h2>
                        <div className="column-content" style={{ backgroundColor: theme.palette.background.medium }}>

                            {/* mostrar mensaje mientras cargan los elementos */}
                            {loadingTasks && (
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                    <CircularProgress size={20} />
                                    <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
                                        Cargando elementos...
                                    </Typography>
                                </Box>
                            )}

                            {column.items && column.items.length > 0 && !loadingTasks ? (
                                column.items.map(item =>
                                    columnId === 'pending' ? cardTask(item, draggedTask && draggedTask.id === item.id) : cardOt(item, draggedTask && draggedTask.id === item.id, column.status)
                                )
                            ) : column.items && column.items.length === 0 && !loadingTasks ? (
                                <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
                                    No hay elementos
                                </Typography>
                            ) : null}
                        </div>
                    </div>
                )
            })}
        </Box>
    );
};

export default Kanban;
